/**
 * User Growth API
 * Operational user-growth dashboard endpoints (admin only).
 */

import apiClient from './client';

export interface GrowthSummary {
  today_new_users: number;
  today_active_regular: number;
  today_active_total: number;
  new_users_7d: number;
  d1_retention_7d: number | null;
}

export interface DailyGrowthRow {
  date: string;
  new_users_ios: number;
  new_users_android: number;
  new_users_unknown: number;
  active_regular: number;
  active_team: number;
}

export interface ActiveUserRow {
  date: string;
  user_id: string;
  display_name: string;
  classification: string;
  registered_at: string | null;
  is_new_user: boolean;
  platform: string | null;
  sessions: number;
  runs: number;
}

export interface GrowthFunnel {
  registered: number;
  created_self_chart: number;
  first_conversation: number;
  returned: number;
}

const BASE = '/user-growth';

export const userGrowthApi = {
  getSummary: async (): Promise<GrowthSummary> => {
    const response = await apiClient.get(`${BASE}/summary`);
    return response.data;
  },

  getDaily: async (days: number): Promise<DailyGrowthRow[]> => {
    const response = await apiClient.get(`${BASE}/daily`, { params: { days } });
    return response.data;
  },

  getActiveUsers: async (params: {
    days: number;
    classification?: string;
    exclude_team?: boolean;
  }): Promise<ActiveUserRow[]> => {
    const response = await apiClient.get(`${BASE}/active-users`, { params });
    return response.data;
  },

  getFunnel: async (days = 30): Promise<GrowthFunnel> => {
    const response = await apiClient.get(`${BASE}/funnel`, { params: { days } });
    return response.data;
  },
};
